import React, { FC } from 'react';
import styled from 'styled-components';
import { FieldValue, FieldValueType } from 'api/tasks';
import { TaskFields } from 'components/molecules/tasks/details/task-fields';
import { NumberField } from 'components/organisms/tasks/fields';
import { useEffortField } from 'data/fields/hooks';
import { ProjectTemplateTask } from 'data/templates/projects';
import { useCustomTaskFields } from 'queries';

/**
 * TODO:: This is a workaround until task-fields table takes a fields
 * array that also has disabled/readonly property support. While this
 * is something that still needs some investigation as how to render
 * and what to render, using this interim workaround to disable stuff.
 */
const TaskFieldsWrapper = styled.div`
  [class*='editable-cell_date_picker'] {
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const TaskFieldsSection: FC<{
  task: ProjectTemplateTask;
  onUpdateTask(task: ProjectTemplateTask): void;
}> = ({ task, onUpdateTask }) => {
  const { data: fields = [] } = useCustomTaskFields();

  const effortField = useEffortField();

  const onFieldValueChange = (value: FieldValue<FieldValueType>) => {
    const taskFields = (task.fields || []).filter(
      (f) => f.fieldId !== value.fieldId,
    );

    onUpdateTask({ ...task, fields: [...taskFields, value] });
  };

  const updateEffort = (value: number | null) =>
    onUpdateTask({ ...task, effort: value || 0 });

  const updateExternalId = (value: string | null) =>
    onUpdateTask({ ...task, externalRefKey: value || '' });

  return (
    <TaskFieldsWrapper>
      <TaskFields.List
        fields={fields}
        value={task.fields || []}
        onChange={onFieldValueChange}
        externalRefKey={task.externalRefKey}
        effort={task.effort}
        onExternalRefkeyChange={updateExternalId}
        onEffortChange={updateEffort}
        effortField={effortField as unknown as NumberField}
      />
    </TaskFieldsWrapper>
  );
};
